import React from 'react';
import { StyleSheet, Text, TextProps } from 'react-native';
import type { IconBaseProps, IconType } from 'react-icons';
import { AiOutlineGoogle } from 'react-icons/ai';

interface IconProps extends TextProps {
  name: string;
  size?: number;
  color?: string;
}

const toElement = (Icon: IconType) => {
  return (props: IconBaseProps) => Icon(props) as React.JSX.Element;
};

const ICON_MAP: Record<string, (props: IconBaseProps) => React.JSX.Element> = {
  google: toElement(AiOutlineGoogle),
};

const AntDesign: React.FC<IconProps> = ({ name, size = 16, color = '#000', style, ...rest }) => {
  // Avoid forwarding pointerEvents as a DOM prop (react-native-web deprecation).
  // Extract pointerEvents from rest and merge into style instead.
  const { pointerEvents, ...restProps } = rest as any;
  const IconComponent = ICON_MAP[name];
  if (!IconComponent) {
    return (
      <Text style={[styles.fallback(size, color), style, pointerEvents ? ({ pointerEvents } as any) : null]} {...restProps}>
        {name}
      </Text>
    );
  }

  const flattened = StyleSheet.flatten(style) ?? {};
  const finalSize = (flattened as any).fontSize ?? size;
  const finalColor = (flattened as any).color ?? color;

  // If pointerEvents was provided, merge it into the flattened style before rendering
  const mergedStyle = pointerEvents ? { ...(flattened as any), pointerEvents } : flattened as any;
  return <IconComponent size={finalSize} color={finalColor} style={mergedStyle} />;
};

const styles = {
  fallback: (fontSize: number, fallbackColor: string) => ({
    fontSize,
    color: fallbackColor,
    fontFamily: 'sans-serif',
  }),
};

export default AntDesign;
